export const SET_USER_WALLET = "SET_USER_WALLET";

export const GET_USER_WALLET = "GET_USER_WALLET";

export const POLL_USER_WALLET = "POLL_USER_WALLET"